(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-editorial-hero"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.accio-editorial-hero').forEach((section) => {
    if (section.dataset.deferredVideoBound === 'true') return;
    const video = section.querySelector('video');
    if (!video) return;

    section.dataset.deferredVideoBound = 'true';

    const initializeVideo = () => {
      if (video.dataset.initialized === 'true') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      video.dataset.initialized = 'true';
      video.querySelectorAll('source[data-src]').forEach((source) => {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });

      const revealVideo = () => {
        section.classList.add('is-video-ready');
      };

      video.addEventListener('playing', revealVideo, { once: true });
      video.load();
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    };

    const scheduleVideo = () => {
      const start = () => window.setTimeout(initializeVideo, 250);
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(start, { timeout: 1400 });
      } else {
        start();
      }
    };

    if (document.readyState === 'complete') {
      scheduleVideo();
    } else {
      window.addEventListener('load', scheduleVideo, { once: true });
    }

    const control = section.querySelector('[data-hero-video-control]');
    if (control) {
      control.addEventListener('click', () => {
        initializeVideo();
        if (video.paused) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
          control.classList.remove('is-paused');
          control.setAttribute('aria-label', control.dataset.pauseLabel);
        } else {
          video.pause();
          control.classList.add('is-paused');
          control.setAttribute('aria-label', control.dataset.playLabel);
        }
      });
    }

    const syncBrandFrame = () => {
      section.classList.toggle('is-brand-frame', video.currentTime >= 49.5);
    };

    ['loadedmetadata', 'timeupdate', 'seeked', 'play'].forEach((eventName) => {
      video.addEventListener(eventName, syncBrandFrame);
    });
    syncBrandFrame();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accio-product-lines"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.accio-product-lines').forEach((section) => {
    if (section.dataset.bound === 'true') return;
    section.dataset.bound = 'true';
    const track = section.querySelector('[data-collection-track]');
    const previous = section.querySelector('[data-collection-previous]');
    const next = section.querySelector('[data-collection-next]');
    const cards = track?.querySelectorAll('.accio-product-lines__card');
    if (!track || !cards?.length) return;

    let autoplayTimer;
    let autoplayPaused = false;
    const autoplayDelay = 3600;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const cardStep = () => {
      const firstCard = cards[0];
      const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
      return firstCard.getBoundingClientRect().width + gap;
    };

    const scrollByCard = (direction) => {
      track.scrollBy({
        left: direction * cardStep(),
        behavior: 'smooth'
      });
    };

    const scheduleAutoplay = () => {
      window.clearTimeout(autoplayTimer);
      if (autoplayPaused || reducedMotion.matches || track.scrollWidth <= track.clientWidth + 2) return;

      autoplayTimer = window.setTimeout(() => {
        if (!section.isConnected || document.hidden) {
          scheduleAutoplay();
          return;
        }

        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
        if (atEnd) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollByCard(1);
        }
        scheduleAutoplay();
      }, autoplayDelay);
    };

    const pauseAutoplay = () => {
      autoplayPaused = true;
      window.clearTimeout(autoplayTimer);
    };

    const resumeAutoplay = () => {
      autoplayPaused = false;
      scheduleAutoplay();
    };

    previous?.addEventListener('click', () => {
      scrollByCard(-1);
      scheduleAutoplay();
    });
    next?.addEventListener('click', () => {
      scrollByCard(1);
      scheduleAutoplay();
    });

    section.addEventListener('mouseenter', pauseAutoplay);
    section.addEventListener('mouseleave', resumeAutoplay);
    track.addEventListener('pointerdown', pauseAutoplay);
    track.addEventListener('pointerup', resumeAutoplay);
    track.addEventListener('pointercancel', resumeAutoplay);
    track.addEventListener('focusin', pauseAutoplay);
    track.addEventListener('focusout', resumeAutoplay);
    reducedMotion.addEventListener?.('change', scheduleAutoplay);
    document.addEventListener('visibilitychange', scheduleAutoplay);

    scheduleAutoplay();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belle-lilysilk-header"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-belle-lily-header]').forEach((header) => {
    if (header.dataset.bound === 'true') return;
    header.dataset.bound = 'true';

    const wrapper = header.closest('.belle-lily-header-wrapper');
    const stickyStart = wrapper.getBoundingClientRect().top + window.scrollY + 8;
    const updateStickyState = () => {
      header.classList.toggle('is-sticky', window.scrollY > stickyStart);
    };

    window.addEventListener('scroll', updateStickyState, { passive: true });
    updateStickyState();

    header.querySelectorAll('.belle-lily-header__drawer a').forEach((link) => {
      link.addEventListener('click', () => {
        link.closest('details').removeAttribute('open');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
